<template>
  <iColumn
    gap="small"
    width="fill"
    role="alert"
    :style-overrides="{
      backgroundColor: 'notice',
      borderRadius: 'standard',
      paddingTop: 'standard',
      paddingBottom: 'standard',
      paddingLeft: 'standard',
      paddingRight: 'standard',
    }"
  >
    <iRow gap="small" vertical-align="middle" wrap="nowrap">
      <iIcon name="ic:outline-info" size="small" variant="notice" />
      <iText font-weight="dark">
        {{ headline }}
      </iText>
      <iRow
        v-if="deniedDeviceLabels.length"
        gap="extraSmall"
        width="hug"
        wrap="nowrap"
      >
        <iBadge
          v-for="device in deniedDeviceLabels"
          :key="device"
          :label="device"
          variant="warning"
          size="small"
        />
      </iRow>
    </iRow>
    <iText variant="subtle">
      {{ message }}
    </iText>
    <iRow gap="small" width="hug" wrap="nowrap">
      <iButton
        v-if="showRetryAccess"
        variant="primary"
        size="small"
        :is-loading="isRequestingDevicePermission"
        :disabled="isRequestingDevicePermission"
        @click="$emit('retry-access')"
      >
        {{ isRequestingDevicePermission ? "Checking…" : "Retry access" }}
      </iButton>
      <iButton
        v-if="showRetryJoin && !isRequestingDevicePermission"
        variant="secondary"
        size="small"
        :disabled="isAutoJoinInProgress"
        @click="$emit('retry-join')"
      >
        Retry join
      </iButton>
    </iRow>
  </iColumn>
</template>

<script>
export default {
  name: "DevicePermissionBanner",
  props: {
    headline: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    deniedDeviceLabels: {
      type: Array,
      default: () => [],
    },
    isRequestingDevicePermission: {
      type: Boolean,
      default: false,
    },
    isAutoJoinInProgress: {
      type: Boolean,
      default: false,
    },
    showRetryJoin: {
      type: Boolean,
      default: false,
    },
    showRetryAccess: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["retry-access", "retry-join"],
};
</script>
